// 依照 API /air-transfer/provider/policy 回傳的資料為主
// export const ORDER_MIN_TIME_AFTER_DAYS = 3
// export const ORDER_MIN_CANCELLATION_DAYS = 4

export const EXTRA_STOPS_LIMIT = 1;
export const MAX_PASSENGER_COUNT = 6;

export const SERVICE_ADDON_BABY_SAFETY_SEAT = 'baby_safety_seat';
export const SERVICE_ADDON_CHILD_SAFETY_SEAT = 'child_safety_seat';
export const SERVICE_ADDON_BOOSTER_SEAT = 'booster_seat';
export const SERVICE_ADDON_NAME_SIGN = 'name_sign';
export const SERVICE_ADDON_EXTRA_STOP = 'extra_stop';
export const SERVICE_ADDON_RED_EYE_FEE = 'redeye_fee';
export const ORDER_TYPE_ARRIVAL = 'arrival';
export const ORDER_TYPE_DEPARTURE = 'departure';

/**
 * ACTIONS
 * full - 全額退款
 * part-refund - 部分退款
 * partial - 部分退款
 * none - 不退款
 */
export const ORDER_REFUND_TYPE_FULL = 'full';
/**
 * @deprecated
 */
export const ORDER_REFUND_TYPE_PART_REFUND = 'part-refund';
export const ORDER_REFUND_TYPE_PARTIAL = 'partial';
export const ORDER_REFUND_TYPE_NONE = 'none';

/**
 * STATES
 * if 已經取消
 * refunded - 全額退款
 * part_refunded - 部分退款
 * paid - 已付款 (不退)
 */
export const ORDER_REFUND_TYPE_REFUNDED = 'refunded';
export const ORDER_REFUND_TYPE_PART_REFUNDED = 'part_refunded';
export const ORDER_REFUND_TYPE_PAID = 'paid';
export const ORDER_REFUND_TYPE_FAILED = 'failed';

/**
 *  行銷專區
 */
export const META_TITLE = 'UGO 機場接送';
export const META_DESCRIPTION =
  '雙北接送桃園機場只要 798 元起，業界最低價。提供安全、舒適優質的機場接送服務，24 小時前預約保證派車，搭配全天候專人客服，讓您不管是出差出國返鄉都安心！';

// 首頁的 banner
export const MARKETING_BANNER_LINK = undefined;
// banner 右下角的顏色自己摳
export const MARKETING_BANNER_BG = '#1c1d1a';
